export const TITLES = {
  homeimprovement:
    'What types of work does your business undertake? Please select all relevant work types (at least one must be selected)',
  other:
    'What type of work does your business undertake? Please select the most relevant work type',
};
